import { Typography,Box,IconButton, TextField,makeStyles } from "@material-ui/core";
import DeleteOutlineRoundedIcon from '@material-ui/icons/DeleteOutlineRounded';
export default function FieldProduct(props) {
  const {
    id,
    label,
    placeholder,
    error,
    onDelete,
    onChangeQty,
    value,
    ...rest
  } = props;
  const cls = fieldStyles();
  return (
    <Box className={cls.container_field}>
      <Typography>{label}</Typography>
      <TextField
        value={value}
        fullWidth
        size="small"
        variant="outlined"
        className={cls.field}
        id={`input-${id}`}
        placeholder={placeholder}
        error={error}
        label="Cantidad"
        type="number"
        onChange={(e) => onChangeQty(e.target.value)}
        {...rest}
      />
      <IconButton onClick={() => onDelete()}>
        <DeleteOutlineRoundedIcon />
      </IconButton>
    </Box>
  );
}

const fieldStyles = makeStyles((theme) => ({
  container_field: {
    display: "grid",
    gridTemplateColumns: "1fr 0.5fr 0.25fr",
    gap: 5,
    width: "100%",
    alignItems: "center",
  },
  field: {
    "& fieldset": {
      borderRadius: theme.spacing(4),
    },
    "& .MuiFormHelperText-root": {
      lineHeight: 1,
    },
  },
}));